import axios from 'axios';
import { uiMessage } from './uiText';

function result(response) {
    if (response.data.code !== 200) throw new Error(response.data.msg || '服务器处理失败。');
    const data = response.data.data;
    if (!data?.originalSaved || !['PARSED', 'CONFIRMED'].includes(data.status) || !data.bundle) {
        const error = new Error(data?.message || '文件未成功保存或解析，请重试。');
        error.issues = data?.issues || []; error.originalSaved = !!data?.originalSaved; throw error;
    }
    return data;
}
const headers = () => ({ Authorization: localStorage.getItem('userInfo') || '' });
export async function uploadNetwork(file, network, signal) {
    const form = new FormData(); form.append('file', file); form.append('gene', network.gene);
    if (network.datasetVersion) form.append('datasetVersion', network.datasetVersion);
    if (network.unitId) form.append('unitId', network.unitId);
    try { return result(await axios.post('/api/rgnet/uploads', form, { headers: headers(), signal, timeout: 60000 })); }
    catch (error) { error.message = uiMessage(error.response?.data?.msg || error.message, '上传失败或未收到保存结果，请重试。'); throw error; }
}
export async function confirmNetworkUpload(id, build, signal) {
    try { return result(await axios.post(`/api/rgnet/uploads/${encodeURIComponent(id)}/confirm`, { genomeBuild: build, confirmed: true }, { headers: headers(), signal, timeout: 30000 })); }
    catch (error) { error.message = uiMessage(error.response?.data?.msg || error.message, '确认保存失败，当前网络保持原样，请重试。'); throw error; }
}
